import I18n from 'i18n-js';
import React from 'react';

import RecentlyViewedListings from '@reverbdotcom/commons/src/cms/components/recently_viewed_listings';
import CMSSearchInputGroup from '@reverbdotcom/commons/src/components/cms_search_input_group';
import { OverflowingRowAction } from '@reverbdotcom/commons/src/components/overflowing_row_action';
import WatchedListings from '@reverbdotcom/commons/src/components/watched_listings';
import { getItem } from '@reverbdotcom/commons/src/local_storage_utils';
import HomepageDealsAndStealsListingsCollection from '../../../../components/homepage_deals_and_steals_listings_collection';
import CPRecommendationsListingsRow from '../../../recommended_listings/cp_recommendations_listings_row';
import { Paths } from '../../../shared/url_helpers';
import RegionalListingsRow from '../../regional_listings';
import { buildRecentSearches } from '@reverbdotcom/commons/src/components/site_search/reverb_site_search_suggestions';
import HomepageSearchRecommendationsContent from '../homepage_search_recommendations';
import { JustListedForYouRow } from '../just_listed_for_you';
import { reverb_search_ListingsSearchRequest_Sort } from '@reverbdotcom/commons/src/gql/graphql';
import RQLHomePageFeed from '../../../../feed/rql_homepage_feed';
import { useShowCountryFlags } from '@reverbdotcom/commons/src/listing_helpers';

export { RQLHomePageFeed as FromYourFeed };

import RecommendedCspsRow from '../../../recommended_csps_row';

export { RecommendedCspsRow };


export function HomepageRecentlyViewedListings() {
  const showFlags = useShowCountryFlags();

  return (
    <RecentlyViewedListings
      title={I18n.t('discovery.homepage.recentlyViewed')}
      layoutSection="main"
      pagePosition={1}
      ssr={true}
      showFlags={showFlags}
    />
  );
}

export function RecommendedForYouCP() {
  return (
    <CPRecommendationsListingsRow
      title={I18n.t('discovery.recommendedListings.cpRecommendationsTitle')}
      listingsLimit={6}
      recsLimit={12}
      sort={reverb_search_ListingsSearchRequest_Sort.LIKELIHOOD_TO_SELL}
    />
  );
}

export function HomepageSearchRecommendations() {
  const recentSearches = buildRecentSearches(getItem('RECENT_SEARCHES') || [])?.suggestions[0]?.results || [];
  return <HomepageSearchRecommendationsContent recentSearches={recentSearches} />;
}

export function JustListedForYou() {
  return (
    <JustListedForYouRow indentedMosaic ssr />
  );
}

export function DealsAndSteals() {
  return (
    <HomepageDealsAndStealsListingsCollection
      maxCount={6}
    />
  );
}

export function RegionalListings() {
  return <RegionalListingsRow />;
}

export function FromYourWatchlist() {
  const showFlags = useShowCountryFlags();

  return (
    <WatchedListings
      mainCallToAction={(
        <OverflowingRowAction
          href={Paths.myFavorites.expand({})}
          text={I18n.t('commons.watchRow.loggedIn.cta')}
        />
      )}
      secondaryCallToAction={(
        <>
          <div className="inner-call-to-action__mobile">
            <CMSSearchInputGroup
              actionUrl={Paths.marketplace.expand({})}
              placeholder={I18n.t('commons.watchRow.loggedIn.emptyState.condensedCta')}
            />
          </div>
          <div className="inner-call-to-action__non-mobile">
            <CMSSearchInputGroup
              actionUrl={Paths.marketplace.expand({})}
              placeholder={I18n.t('commons.watchRow.loggedIn.emptyState.cta')}
            />
          </div>
        </>
      )}
      showFlags={showFlags}
    />
  );
}
